import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { Theme } from '../../utils/theme';
import Text from './Text';

interface AppHeaderProps {
  showBackButton?: boolean;
  onBackPress?: () => void;
}

export default function AppHeader({ showBackButton = false, onBackPress }: AppHeaderProps) {
  const navigation = useNavigation();

  const handleBackPress = () => {
    if (onBackPress) {
      onBackPress();
    } else {
      navigation.goBack();
    }
  };

  return (
    <View style={styles.header}>
      <View style={styles.logoContainer}>
        <View style={styles.logo}>
          <View style={styles.logoIcon}>
            {/* Logo icon placeholder - you can replace with actual logo */}
            <View style={styles.logoIconPlaceholder} />
          </View>
          <Text variant="heading2" style={styles.mentorist}>
            mentorist
          </Text>
        </View>
        
        {showBackButton && (
          <Pressable style={styles.leftIcon} onPress={handleBackPress}>
            <Ionicons name="chevron-back" size={24} color={Theme.colors.textPrimary} />
          </Pressable>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: 'rgba(255, 255, 255, 0.01)',
    justifyContent: 'center',
    alignSelf: 'stretch',
    alignItems: 'center',
    paddingVertical: Theme.spacing.sm,
  },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: Theme.spacing.sm,
    gap: Theme.spacing.sm,
    alignSelf: 'stretch',
  },
  logo: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 46,
    gap: Theme.spacing.xs,
  },
  logoIcon: {
    width: 22,
    height: 22,
  },
  logoIconPlaceholder: {
    width: 22,
    height: 22,
    borderRadius: Theme.borderRadius.sm,
    backgroundColor: Theme.colors.primary,
  },
  mentorist: {
    color: Theme.colors.textPrimary,
    fontFamily: Theme.typography.fontFamily.semiBold,
  },
  leftIcon: {
    position: 'absolute',
    left: Theme.spacing.sm,
    top: 13,
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
  },
}); 